<template>
  <v-container v-if="!editMode" class="py-0">
    <v-list-item class="pl-0">
      <v-list-item-icon class="ma-0 mr-3 my-auto" style="height: unset;">
        <MachineModelImage :size="assetTypesEnabled && assettype ? 80 : 60"
          :relativePath="machinemodel && machinemodel.ModelImage" />
      </v-list-item-icon>
      <v-list-item-content class="py-0">
        <v-list-item-subtitle v-if="supplier">
          <v-btn text class="px-1 mr-1" style="min-width: unset; height: 26px; text-transform: none;"
            :to="{ name: 'ViewSupplier', params: { supplierId: supplier.Id } }">
            {{ supplier && supplier.Name }}
          </v-btn>
          <v-btn v-if="machinemodel" text class="px-1" style="min-width: unset; height: 26px; text-transform: none;"
            :to="{ name: 'ViewMachineType', params: { typeId: machinetype.Id } }">
            {{ machinetype && machinetype.Name }}
          </v-btn>
        </v-list-item-subtitle>

        <v-list-item-title class="my-auto">
          <v-btn v-if="machinemodel" text class="px-1" style="min-width: unset; height: 26px; text-transform: none;"
            :to="{ name: 'ViewMachineModel', params: { modelId: machinemodel.Id } }">
            <b>{{ machinemodel.Name }}</b>
          </v-btn>
          <b v-else class="mb-0 px-1">
            Unspecified model
          </b>
        </v-list-item-title>

        <v-list-item-subtitle v-if="assettype">
          <v-btn text class="px-1" style="min-width: unset; height: 26px; text-transform: none;"
            :to="{ name: 'AssetTypes' }">
            {{ assettype && assettype.Name }}
          </v-btn>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-container>

  <v-container v-else fluid class="pt-0">
    <SupplierSelect v-if="!disableFiltersOnModelSelect" :key="(supplier && supplier.Id) + '-sus'" v-model="supplier"
      :loading="modelLoading" :clearable="!machinemodel" allowCreate returnobject :disableAttach="disableAttach"
      :externaledit="isNew || editMode" :disabled="!!machinemodel" class="mb-3">
    </SupplierSelect>
    <MachineTypeSelect v-if="!disableFiltersOnModelSelect" :key="(machinetype && machinetype.Id) + '-mts'"
      v-model="machinetype" :loading="modelLoading" :clearable="!machinemodel" allowCreate returnobject
      :disableAttach="disableAttach" :externaledit="isNew || editMode" :disabled="!!machinemodel" class="mb-3">
    </MachineTypeSelect>
    <MachineModelSelect :key="'mms-' + (supplier && supplier.Id) + '-' + (machinetype && machinetype.Id)"
      v-model="machinemodel" :loading="modelLoading" :filter="modelFilter" clearable allowCreate returnobject
      :externaledit="isNew || editMode" :disableAttach="disableAttach" class="mb-3">
      <template v-if="!disableFiltersOnModelSelect && (!!supplier || !!machinetype)" v-slot:append-outer>
        <v-icon size="18" color="tertiary">mdi-filter</v-icon>
      </template>
    </MachineModelSelect>
    <AssetTypeSelect v-if="assetTypesEnabled" v-model="assettype" :clearable="!assetTypeRequired" allowCreate
      :disableAttach="disableAttach" returnobject :externaledit="isNew || editMode">
    </AssetTypeSelect>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import AssetTypeSelect from "@/components/Inputs/EntityDropdowns/AssetTypeSelect2.vue";
import MachineModelSelect from '@/components/Inputs/EntityDropdowns/MachineModelSelect2.vue';
import MachineTypeSelect from '@/components/Inputs/EntityDropdowns/MachineTypeSelect2.vue';
import SupplierSelect from '@/components/Inputs/EntityDropdowns/SupplierSelect2.vue';
import MachineModelImage from "@/views/job/newjob/cards/machines/MachineModelImage.vue";
import Vue from "vue";

export default {
  name: "MachineEditContent",
  props: {
    editItem: Object,
    editMode: Boolean,
    handleFocus: Function,
    disableAttach: Boolean,
  },
  components: {
    MachineModelImage,
    MachineModelSelect,
    MachineTypeSelect,
    SupplierSelect,
    AssetTypeSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      filterResetKey: 1,
      modelLoading: false,
      modelSupplierId: null,
      modelTypeId: null,
    };
  },

  mounted() { },

  methods: {},

  computed: {
    isNew() {
      return this.editItem?.Id == null;
    },

    modelFilter() {
      if (this.disableFiltersOnModelSelect) {
        return {}
      }
      else {
        return {
          SupplierIdList: this.supplier != null ? [this.supplier.Id] : [],
          MachineTypeIdList: this.machinetype != null ? [this.machinetype.Id] : [],
        }
      }
    },

    supplier: {
      get() {
        if (this.editItem.MachineModel) {
          return this.editItem.MachineModel.Supplier;
        }
        else {
          return this.editItem.Supplier;
        }
      },
      set(value) {
        if (this.editItem.MachineModel && (value?.Id != this.editItem.MachineModel.Supplier.Id)) {
          this.editItem.MachineModel = null;
        }
        Vue.set(this.editItem, 'Supplier', value);
      }
    },

    machinetype: {
      get() {
        if (this.editItem.MachineModel) {
          return this.editItem.MachineModel.MachineType;
        }
        else {
          return this.editItem.MachineType;
        }
      },
      set(value) {
        if (this.editItem.MachineModel && (value?.Id != this.editItem.MachineModel.MachineType.Id)) {
          this.editItem.MachineModel = null;
        }
        Vue.set(this.editItem, 'MachineType', value);
      }
    },

    machinemodel: {
      get() {
        return this.editItem.MachineModel;
      },
      set(value) {
        this.editItem.MachineModel = value;
        if (value) {
          this.machinetype = value.MachineType;
          this.supplier = value.Supplier;
        }
      }
    },

    assettype: {
      get() {
        return this.editItem.AssetType;
      },
      set(value) {
        this.editItem.AssetType = value;
      }
    },

    disableFiltersOnModelSelect() {
      return this.globalSettings.DisableFiltersOnModelSelect;
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    },

    assetTypesEnabled() {
      return this.$store.state.GlobalSettings.Features.AssetTypesEnabled;
    },

    serialNumberRequired() {
      return this.$store.state.GlobalSettings.SerialNumberRequired;
    },

    assetTypeRequired() {
      return this.$store.state.GlobalSettings.AssetTypeRequired;
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>